import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import MonthlyEarningGapsTable from "./MonthlyEarningGapsTable";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  billing_month: "Billing Month",
  earning_gap: "Earning Gap",
  previous_total_income: "Previous Total Income",
  current_total_income: "Current Total Income",
  data_capture_date: "Data Capture Date",
};
const rows = [
  {
    brand_name: "BetVictor Sport UK",
    brand_id: 2319,
    billing_month: "21/04/2026",
    earning_gap: "25",
    previous_total_income: "$14,855",
    current_total_income: "$14,855",
    data_capture_date: "30/04/2026",
  },
  {
    brand_name: "Gentleman Jim Sport UK",
    brand_id: 2367,
    billing_month: "21/04/2026",
    earning_gap: "1055",
    previous_total_income: "$14,855",
    current_total_income: "$14,855",
    data_capture_date: "30/04/2026",
  },
];

const MonthlyEarningGaps = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Monthly Earning Gaps in MTD
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <MonthlyEarningGapsTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default MonthlyEarningGaps;
